import { Box, CircularProgress } from "@material-ui/core";

export interface BoxedLoaderProps {
  height?: string;
}

export const BoxedLoader = (props: BoxedLoaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        minHeight: props.height || "100px",
      }}
    >
      <CircularProgress />
    </Box>
  );
};
